// 設定画面用スタイル
import './admin.scss';
import { createRoot } from 'react-dom/client';
import Quiz from './component/Quiz';

// Adminコンポーネント
const Admin = (settings: any) => {
  return (
    <Quiz
      selectId={settings.settings.selectQuizId}
      selectQuizName={settings.settings.selectQuizName}
      url={settings.settings.url}
    />
  )
};

// AdminコンポーネントをルートDOMにレンダリング
const root = createRoot(document.getElementById('my-gutenberg-admin-plugin'));
const rootEl = document.getElementById('my-gutenberg-admin-plugin')
const settings = JSON.parse( rootEl.getAttribute( 'data-default-settings' ) );
root.render(<Admin settings={settings} />)
